<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t('$vuetify.map.driverSettings.syncDialog.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        {{ $vuetify.lang.t(cardText) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red lighten-1" @click="sendRejectState">{{
          $vuetify.lang.t('$vuetify.map.driverSettings.syncDialog.reject') }}
        </v-btn>
        <v-btn text color="light-green" @click="sendConfirmState">{{
          $vuetify.lang.t('$vuetify.map.driverSettings.syncDialog.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { SyncDialogStates } from '../../enum'

export default {
  name: 'driverSettingsSyncConfirmation',
  props: {
    dialog: Boolean,
    state: SyncDialogStates
  },
  data: () => ({
    closeIcon: mdiClose
  }),
  computed: {
    cardText () {
      switch (this.state) {
        case SyncDialogStates.SINGLE:
          return '$vuetify.map.driverSettings.syncDialog.textSingle'
        case SyncDialogStates.SELECTED:
          return '$vuetify.map.driverSettings.syncDialog.textSelected'
        case SyncDialogStates.ALL:
          return '$vuetify.map.driverSettings.syncDialog.textAll'
        default:
          return ''
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('sync-dialog-closed')
    },
    _sendState (state) {
      this.$emit(state)
      this.closeDialog()
    },
    sendRejectState () {
      this._sendState('sync-dialog-reject')
    },
    sendConfirmState () {
      this._sendState('sync-dialog-confirm')
    }
  }
}
</script>

<style scoped>

</style>
